/*jshint esversion: 6 */
// import store from '@/store/index';
import UltraRoute from '@/router/components/UltraRoute.js';
import WorkPackageInfo from '@/router/components/WorkPackageInfo.component.js';
import WorkPackageContent from '@/router/components/WorkPackageContent.component.js';

import WorkPackageEditorModule from '@/router/modules/WorkPackageEditor.module.js';
import MaterialsOverview from '@/router/modules/MaterialsOverview.module.js';
// import ViewStore from '@/store/modules/View.store.js';

// function getOnSite() {
//   // NOTE: check for on_site, must also be set in WorkPackageInfo.component.js
//   return ViewStore.getters['getUseOnSite']();
// }

function StepContent(wallet, location, step_type, backlog, prefix) {

  let grand_children = [
    UltraRoute(
      {
          path: 'images/:image_id',
          folder: 'Project/WorkPackageRework',
          file: 'WorkPackageImagesDetails',
          name: `${location}${step_type}StepWorkPackageImagesDetails`,
          props: {
            location: `${location}${step_type}Step`,
            step_type: `${step_type.toLowerCase()}`,
            nav_back: `${location}WorkPackage${step_type}StepsDetails`
          },
          auth: true,
      }
    )
  ];

  if (step_type == 'Work') {
    grand_children.push(UltraRoute({
      path: 'elements/:element_id',
      folder: 'Project/WorkPackageRework',
      file: 'WorkPackageElementsDetails',
      name: `${location}${step_type}StepWorkPackageElementsDetails`,
      props: {
        location: `${location}${step_type}Step`,
        step_type: `${step_type.toLowerCase()}`,
        nav_back: `${location}WorkPackage${step_type}StepsDetails`
      },
      auth: true,
    }));
    grand_children.push(UltraRoute({
      path: 'avaliable-elements',
      folder: 'Project/WorkPackageRework',
      file: 'WorkPackageAvailableElements',
      name: `${location}${step_type}StepWorkPackageAvailableElements`,
      props: {
        location: `${location}${step_type}Step`,
        step_type: `${step_type.toLowerCase()}`,
        nav_back: `${location}WorkPackage${step_type}StepsDetails`
      },
      auth: true,
    }));
  }


  return WorkPackageContent({content_type: 'Steps', step_type: `${step_type}`, wallet: wallet, backlog: backlog, prefix: prefix,location: location, grand_children: grand_children});
}

function Template(payload) {
  let route = WorkPackageInfo({wallet: payload.wallet, location: payload.location, prefix: payload.prefix, backlog: payload.backlog, children: [


    // WorkPackageContent({content_type: 'Steps', step_type: 'Work', wallet: payload.wallet, backlog: payload.backlog, prefix: payload.prefix, location: payload.location}),
    // WorkPackageContent({content_type: 'Steps', step_type: 'Quality', wallet: payload.wallet, backlog: payload.backlog, prefix: payload.prefix, location: payload.location}),
    // WorkPackageContent({content_type: 'Steps', step_type: 'Defect', wallet: payload.wallet, backlog: payload.backlog, prefix: payload.prefix, location: payload.location}),
    // WorkPackageContent({content_type: 'Steps', step_type: 'Handover', wallet: payload.wallet, backlog: payload.backlog, prefix: payload.prefix, location: payload.location}),
    // WorkPackageContent({content_type: 'Steps', step_type: 'Design', wallet: payload.wallet, backlog: payload.backlog, prefix: payload.prefix, location: payload.location}),
    // WorkPackageContent({content_type: 'Steps', step_type: 'Logistic', wallet: payload.wallet, backlog: payload.backlog, prefix: payload.prefix, location: payload.location}),
    // WorkPackageContent({content_type: 'Steps', step_type: 'Cost', wallet: payload.wallet, backlog: payload.backlog, prefix: payload.prefix, location: payload.location}),
    // WorkPackageContent({content_type: 'Steps', step_type: 'Material', wallet: payload.wallet, backlog: payload.backlog, prefix: payload.prefix, location: payload.location}),
    // WorkPackageContent({content_type: 'Steps', step_type: 'Tool', wallet: payload.wallet, backlog: payload.backlog, prefix: payload.prefix, location: payload.location}),
    // WorkPackageContent({content_type: 'Steps', step_type: 'Sensor', wallet: payload.wallet, backlog: payload.backlog, prefix: payload.prefix, location: payload.location}),
    // WorkPackageContent({content_type: 'Steps', step_type: 'Robotic', wallet: payload.wallet, backlog: payload.backlog, prefix: payload.prefix, location: payload.location}),


    StepContent(payload.wallet, payload.location, 'Work', payload.backlog, payload.prefix),
    StepContent(payload.wallet, payload.location, 'Quality', payload.backlog, payload.prefix),
    StepContent(payload.wallet, payload.location, 'Defect', payload.backlog, payload.prefix),
    StepContent(payload.wallet, payload.location, 'Handover', payload.backlog, payload.prefix),
    StepContent(payload.wallet, payload.location, 'Design', payload.backlog, payload.prefix),
    StepContent(payload.wallet, payload.location, 'Logistic', payload.backlog, payload.prefix),
    StepContent(payload.wallet, payload.location, 'Cost', payload.backlog, payload.prefix),
    // StepContent(payload.wallet, payload.location, 'Material', payload.backlog, payload.prefix),
    StepContent(payload.wallet, payload.location, 'Machine', payload.backlog, payload.prefix),
    StepContent(payload.wallet, payload.location, 'Sensor', payload.backlog, payload.prefix),
    StepContent(payload.wallet, payload.location, 'Robotic', payload.backlog, payload.prefix),
    WorkPackageContent({content_type: 'Steps', step_type: 'Material', wallet: payload.wallet, backlog: payload.backlog, prefix: payload.prefix, location: payload.location, grand_children: [
      MaterialsOverview({location: `${payload.location}WorkPackageMaterialStep`, show_add: true}),
      UltraRoute(
        {
            path: 'images/:image_id',
            folder: 'Project/WorkPackageRework',
            file: 'WorkPackageImagesDetails',
            name: `${payload.location}MaterialStepWorkPackageImagesDetails`,
            props: {
              location: `${payload.location}MaterialStep`,
              step_type: `material`,
              nav_back: `${payload.location}WorkPackageMaterialStepsDetails`
            },
            auth: true,
        }
      )
    ]}),

    // WorkPackageContent({content_type: 'Camera', wallet: payload.wallet, location: payload.location}),
    UltraRoute({path: 'camera', name: `${payload.location}WorkPackageCamera`, folder:'Project/WorkPackageRework', file: 'WorkPackageImagesDetails', auth: true, props: {backlog: payload.backlog, prefix: payload.prefix, location: payload.location}}),


    UltraRoute({path: 'images', name: `${payload.location}WorkPackageImages`, folder:'Project/WorkPackageRework', file: 'WorkPackageImages', auth: true, props: {wallet: payload.wallet, backlog: payload.backlog, prefix: payload.prefix, location: payload.location}, children: [
      UltraRoute({path: ':image_id', name: `${payload.location}WorkPackageImagesDetails`, folder:'Project/WorkPackageRework', file: 'WorkPackageImagesDetails', auth: true, props: {wallet: payload.wallet, backlog: payload.backlog, prefix: payload.prefix, location: payload.location, nav_back: `${payload.location}WorkPackageImages`}, })
    ]}),

    // WorkPackageContent({content_type: 'Images', wallet: payload.wallet, backlog: payload.backlog, prefix: payload.prefix, location: payload.location}),
    WorkPackageContent({content_type: 'Files', wallet: payload.wallet, backlog: payload.backlog, prefix: payload.prefix, location: payload.location}),
    WorkPackageContent({content_type: 'QRCodes', wallet: payload.wallet, backlog: payload.backlog, prefix: payload.prefix, location: payload.location}),
    WorkPackageContent({content_type: 'Contacts', wallet: payload.wallet, backlog: payload.backlog, prefix: payload.prefix, location: payload.location}),
    WorkPackageContent({content_type: 'Costs', wallet: payload.wallet, backlog: payload.backlog, prefix: payload.prefix, location: payload.location}),
    WorkPackageContent({content_type: 'LogList', wallet: payload.wallet, backlog: payload.backlog, prefix: payload.prefix, location: payload.location}),
    WorkPackageContent({content_type: 'AdditionalInformation', wallet: payload.wallet, backlog: payload.backlog, prefix: payload.prefix, location: payload.location}),

    WorkPackageContent({content_type: 'Autopilots', wallet: payload.wallet, location: payload.location}),
    WorkPackageContent({content_type: 'TimeRecord', wallet: payload.wallet, location: payload.location, backlog: payload.backlog, prefix: payload.prefix}),
    // WorkPackageContent({content_type: 'MessageBoard', wallet: payload.wallet, location: payload.location}),


    // WorkPackageContent({content_type: 'Elements', wallet: payload.wallet, location: payload.location}),
    // Elements
    UltraRoute({
      path: 'elements',
      name: `${payload.location}WorkPackageElements`,
      auth: true,
      folder: 'Project/WorkPackageRework',
      file: 'WorkPackageElements',
      props: {
        location: `${payload.location}`
      },
      children: [
        UltraRoute({
          path: ':element_id',
          name: `${payload.location}WorkPackageElementsDetails`,
          auth: true,
          folder: 'Project/WorkPackageRework',
          file: 'WorkPackageElementsDetails',
          props: {
            location: `${payload.location}`,
            nav_back: `${payload.location}WorkPackageElements`
          },
        })
      ]
    }),

    //redirect quickfix workpackage edit exists no longer
    UltraRoute({path: 'edit', name: `${payload.location}WorkPackageEdit`, redirect: 'TaktPlanWorkPackageInfo', auth: true}),
  ]});

  if (!payload.wallet) {
    route.children.push(
      WorkPackageEditorModule({
        path: 'copy/:workpackage_id',
        location: `${payload.location}WorkPackageCopy`,
        read_only: false,
        create: true,
        prefix: '',
        nav_back: 'TaktPlanWorkPackageEdit',
      })
    );
  }

  if (payload && payload.children) {
    route.children = payload.children;
  }
  return route;
}
export default Template;
